<script setup lang="ts">
import { Combobox } from '@ark-ui/vue'
import { provide } from 'vue'
import UiText from './UiText.vue'

export interface UiComboboxGroupProps {
    id: string
    label?: string
    showImage?: boolean
}

const props = defineProps<UiComboboxGroupProps>()
provide('groupShowImage', props.showImage)
</script>

<template>
    <Combobox.ItemGroup :id="props.id" class="flex flex-col gap-1">
        <Combobox.ItemGroupLabel :for="props.id" class="px-4 py-2 flex flex-col items-stretch">
            <slot name="heading" :label="props.label" :id="props.id">
                <UiText as="span" variant="small" class="font-semibold text-se-gray-500">
                    {{ props.label }}
                </UiText>
            </slot>
        </Combobox.ItemGroupLabel>
        <slot />
    </Combobox.ItemGroup>
</template>
